// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"gallery-module--cardContainer--2FWin","cardText":"gallery-module--cardText--1yLXz","cardImageTitle":"gallery-module--cardImageTitle--3XpzF"};